export enum enumDiscountType {
    None = 0,
    PercentageBased = 1,
    FixedAmount = 2,
    DiscountCode = 3
};